import _ from "lodash";
import {addEditDPServiceActionTypes} from "../constants/AddEditActionConstants";
import INPUT_FIELDS from "../../../common/resources/inputfields.json"

const initialState = {
    addNewDPService: false,
    updatedDPService: false,
    modalOpenDPService: false,
    editModalOpenDPService: false,
    showReqInputsOptions: false,
    dpServiceModalHeader: "",
    requiredInputs: [],
    editInputsArray: [],
    formattedIpKeys: [],
    inputsArray: [],
    all_billing_groups: [],
    all_service_config_names: [],
    all_service_sets: [],
    selectedServiceSet: null,
    available_service_config_names: [],
    editArrayIndex: null,
    addSvcConfigNames: [],
    toDelete: {
        service_config_names: [],
        input_keys: []
    },
    toCreate: {},
    serviceObject: {
        service_detail: {
            service_id: "",
            service_name: "",
            billing_group_id: "",
            created_date: "",
            dp_type: "",
            integration_status: false,
            is_deleted: false,
            last_updated: "",
            provider: "",
        },
        associated_dp: {
            provider_id: "",
            created_date: "",
            is_deleted: false,
            last_updated: "",
            monthly_aggregate_volume: null,
            provider_name: "",
        },
        billing_group: {
            billing_group_name: "",
            billing_period: null,
            contract_start_date: null,
            contract_term: null,
            created_date: "",
            currency: "",
            has_fixed: false,
            id: "",
            invoice_name: "",
            is_deleted: false,
            last_updated: "",
            match_rules_id: null,
            monthly_aggregate_volume: null,
            price_model: "",
            tier_type: null,
        },
        contact_info: [
            {
                email: "",
                id: null,
                name: "",
                phone_number: "",
                resource_id: "",
                type: "Technical",
            },
            {
                email: "",
                id: null,
                name: "",
                phone_number: "",
                resource_id: "",
                type: "Business",
            },
        ],
        approvals: {
            id: "",
            resource_id: "",
            is_approved: false,
            approved_on: null,
            approved_by: ""
        },
        notes: [
            {
                note: "",
                notes_id: null,
                resource_id: "",
                type: "Internal"
            },
            {
                note: "",
                notes_id: null,
                resource_id: "",
                type: "External"
            },
        ],
        service_config_names: [],
        input_keys: [],
        associated_sources: []
    },
}


const addEditDPServicesReducer = (state = initialState, action) => {
    switch (action.type) {

        case addEditDPServiceActionTypes.CREATE_DP_SERVICE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.addNewDPService = true;
            newState.modalOpenDPService = true;
            newState.dpServiceModalHeader = "Add a new DP Service";
            return newState;
        }

        case addEditDPServiceActionTypes.SETTING_DPSERVICE_FORM_OBJECT_VALUE: {
            let newState = _.cloneDeep(state);
            newState.serviceObject[action.payload.change_obj][action.payload.name] = action.payload.value;
            return newState;
        }

        case addEditDPServiceActionTypes.EDIT_DP_SERVICE_MODAL: {
            let newState = _.cloneDeep(state);
            newState.editModalOpenDPService = true;
            newState.serviceObject = action.payload.detailObject;
            newState.dpServiceModalHeader = "Edit DP Service - " + newState.serviceObject.service_detail.service_name;
            return newState;
        }

        case addEditDPServiceActionTypes.PREP_INPUT_KEYS: {
            let newState = _.cloneDeep(state);
            // prep input-keys
            newState.inputKeysObject = newState.serviceObject.input_keys;
            newState.formattedIpKeys = [];
            newState.inputsArray = {};
            let specificCountriesForIpKeys = [];
            // this is the temp object which is later used to populate the formattedIpKeys array with
            // data in the format to render it in table.
            let temp = {}
            // initialize the main DS with key as country and empty object as value
            newState.inputKeysObject.forEach(i => {
                if (!specificCountriesForIpKeys.includes(i.country_iso)) {
                    specificCountriesForIpKeys.push(i.country_iso);
                    temp[i.country_iso] = {}
                    newState.inputsArray[i.country_iso] = {}
                }
            });
            // initialize country objects inside main DS with key as input_group_id and value as empty array
            newState.inputKeysObject.forEach(i => {
                if (i.country_iso in temp) {
                    temp[i.country_iso][i.input_group_id] = []
                    newState.inputsArray[i.country_iso][i.input_group_id] = []
                }
            });
            // populate the DS
            newState.inputKeysObject.forEach(i => {
                if (i.input_group_id in temp[i.country_iso]) {
                    temp[i.country_iso][i.input_group_id].push(i.label_name)
                    i.label_id = _.result(_.find(INPUT_FIELDS,{
                        'label_name': i.label_name
                    }), "label_id");
                    newState.inputsArray[i.country_iso][i.input_group_id].push(i)
                }
            });
            // use the DS to create an array of objects which can be rendered into the table.
            for (let [key, value] of Object.entries(temp)) {
                for (let [k, v] of Object.entries(value)) {
                    newState.formattedIpKeys.push({
                        id: k,
                        country_iso: key,
                        elements: v.join(", ")
                    })
                }
            }
            return newState;
        }

        case addEditDPServiceActionTypes.UPDATED_DP_SERVICE_REFRESH: {
            let newState = _.cloneDeep(state);
            newState.updatedDPService = !newState.updatedDPService;
            return newState;
        }

        case addEditDPServiceActionTypes.CLOSE_DP_SERVICE_MODAL: {
            return initialState;
        }

        case addEditDPServiceActionTypes.MARK_AS_PRIMARY_SERVICE_CONFIG_NAME: {
            let newState = _.cloneDeep(state);
            const updatedPrimaryIndex = String(action.payload.value);
            newState.serviceObject.service_config_names.forEach(svc => {
                svc.is_primary = String(svc.serviceid) === updatedPrimaryIndex;
            })
            return newState;
        }

        case addEditDPServiceActionTypes.ADD_TO_SELECTED_SERVICE_CONFIG_NAMES: {
            let newState = _.cloneDeep(state);
            const incoming = Array.isArray(action.payload)
                ? action.payload
                : (action.payload ? [action.payload] : []);
            newState.addSvcConfigNames = _.unionBy(newState.addSvcConfigNames, incoming, "serviceid");
            return newState;
        }

        case addEditDPServiceActionTypes.ADD_TO_ASSOCIATED_SERVICE_CONFIG_NAMES: {
            let newState = _.cloneDeep(state);
            let ids = new Set(newState.serviceObject.service_config_names.map(d => d.serviceid));
            newState.serviceObject.service_config_names = [...newState.serviceObject.service_config_names,
                ...newState.addSvcConfigNames.filter(d => !ids.has(d.serviceid))];
            newState.addSvcConfigNames = initialState.addSvcConfigNames;
            return newState;
        }

        case addEditDPServiceActionTypes.DELETE_FROM_ASSOCIATED_SERVICE_CONFIG_NAMES: {
            let newState = _.cloneDeep(state);
            // capture this id into an array, this will be then passed
            // over to the api to remove the association from the table
            newState.toDelete.service_config_names.push(action.payload.value)
            const toDelete = new Set([action.payload.value]);
            newState.serviceObject.service_config_names = newState.serviceObject.service_config_names.filter(
                obj => !toDelete.has(obj.serviceid));
            return newState;
        }

        case addEditDPServiceActionTypes.SELECT_BILLING_GROUP: {
            let newState = _.cloneDeep(state);
            const targetObj = action.payload.change_obj.name
            if (action.payload.bg !== null) {
                newState.serviceObject[targetObj] = action.payload.bg;
                newState.serviceObject.service_detail.billing_group_id = action.payload.bg.id;
            } else {
                newState.serviceObject.billing_group.billing_group_name = "";
                newState.serviceObject.service_detail.billing_group_id = "";
            }
            return newState;
        }

        case addEditDPServiceActionTypes.ADD_NEW_REQUIRED_INPUT_GROUP: {
            let newState = _.cloneDeep(state);
            let ogIpKeys = newState.serviceObject.input_keys
            const t = ogIpKeys.concat(action.payload.editInputsArray)
            newState.serviceObject.input_keys = _.sortBy(t, ["country_iso", "input_group_id"])

            return newState;
        }

        case addEditDPServiceActionTypes.EDIT_EXISTING_INPUT_GROUP: {
            let newState = _.cloneDeep(state);
            let ogIpKeys = newState.serviceObject.input_keys
            const currentEditIpGroup = newState.inputsArray[action.payload.countryCode][action.payload.editIndexOfInputGroup];
            const selectedKeysForUpdate = [action.payload.editInputsArray];
            // filter out the input keys that are deleted as a part of the
            // edit action and capture their ids
            const results = currentEditIpGroup.filter(item1 =>
                !selectedKeysForUpdate.some(item2 => (item2.id === item1.id)))
            const idsOfDeletedInputs = results.map(x => x.id)

            // for every time an input key is deleted from the group capture
            // the ids so they can be first processed by API to delete.
            if (idsOfDeletedInputs.length > 0) {
                newState.toDelete.input_keys.push(idsOfDeletedInputs.toString());
            }

            // from the shallow copy of input_keys, remove the deleted keys
            const toDelete = new Set(idsOfDeletedInputs);
            ogIpKeys = ogIpKeys.filter(obj => !toDelete.has(obj.id));

            // merge the shallow-copy with the selected inputs preserving the uniqueness
            const t = _.unionBy(ogIpKeys, action.payload.editInputsArray, "id")
            // sort this by the input-group-id so that component can render the table effectively.
            newState.serviceObject.input_keys = _.sortBy(t, ["country_iso", "input_group_id"])

            return newState;
        }

        case addEditDPServiceActionTypes.DELETE_SELECTED_INPUT_GROUP:{
            let newState = _.cloneDeep(state);
            let filteredIpKeys = []
            let deletedInputs = []
            newState.serviceObject.input_keys.forEach(obj => {
                if(obj.country_iso === action.payload.countryCode &&
                    obj.input_group_id.toString() === action.payload.deleteIndexOfInputGroup){
                    deletedInputs.push(obj)
                } else {
                    // after deleting the input group, update the input-group-id of the resulting groups based on the
                    // deleteIndex by subtracting 1 except where the id < delete index, in that case do nothing.
                    if (action.payload.deleteIndexOfInputGroup.toString() === '0' &&
                        obj.country_iso === action.payload.countryCode) {
                        obj.input_group_id -= 1;
                    } else if (obj.input_group_id.toString() > action.payload.deleteIndexOfInputGroup &&
                        obj.country_iso === action.payload.countryCode) {
                        obj.input_group_id -= 1;
                    }
                    // push the updated object to the filtered array.
                    filteredIpKeys.push(obj)
                }
            });
            newState.serviceObject.input_keys = filteredIpKeys;

            return newState;
        }

        case addEditDPServiceActionTypes.SELECT_DATA_PROVIDER: {
            let newState = _.cloneDeep(state);
            const targetObj = action.payload.change_obj.name
            if (action.payload.bg !== null) {
                newState.serviceObject[targetObj] = action.payload.bg;
                newState.serviceObject.service_detail.provider = action.payload.bg.provider_id;
            }  else {
                newState.serviceObject.service_detail.provider = "";
                newState.serviceObject.associated_dp.provider_name = "";
            }
            return newState;
        }

        case addEditDPServiceActionTypes.UPDATE_DP_TYPE_INTEGRATION_STATUS: {
            let newState = _.cloneDeep(state);
            const targetObj = action.payload.change_obj.name
            if (action.payload.bg !== null) {
                newState.serviceObject.service_detail[targetObj] = action.payload.bg.value
            } else {
                newState.serviceObject.service_detail[targetObj] = "";
            }
            return newState;
        }

        case addEditDPServiceActionTypes.SELECT_SERVICE_SET: {
            let newState = _.cloneDeep(state);
            if (action.payload.bg !== null) {
                newState.selectedServiceSet = action.payload.bg;
                newState.available_service_config_names = action.payload.all_service_config_names.filter(
                    x => x.collectionid === newState.selectedServiceSet.collectionid
                );
            } else {
                newState.available_service_config_names = initialState.available_service_config_names;
            }
            return newState;
        }

        case addEditDPServiceActionTypes.UPDATE_DP_SERVICE_NOTES: {
            let newState = _.cloneDeep(state);
            newState.serviceObject.notes.forEach(note => {
                if (note.type === action.payload.name) {
                    note.note = action.payload.value
                }
            })
            return newState;
        }

        case addEditDPServiceActionTypes.UPDATE_DP_SERVICES_CONTACT: {
            let newState = _.cloneDeep(state);
            newState.serviceObject.contact_info.forEach(contact => {
                if (contact.type === action.payload.name) {
                    contact[action.payload.change_obj] = action.payload.value
                }
            })
            return newState;
        }

        // possibly remove
        case "CREATE_NEW_NOTE": {
            let newState = _.cloneDeep(state);
            let newNote = action.payload.notesObject;
            newNote.type = newNote.setType;
            delete newNote.setType;
            newState.serviceObject.notes.push(newNote)
            return newState;
        }

        default:
            return state;
    }
}

export default addEditDPServicesReducer;
